<template>
  <VApp data-testid="app">
    <SocioBaseNotification />
    <AppRefreshModal />
    <RouterView />
  </VApp>
</template>

<script setup>
  import { defineComponent } from "vue";
  import SocioBaseNotification from "@/components/vigico/SocioBaseNotification.vue";
  import AppRefreshModal from "@/components/vigico/AppRefreshModal.vue";

  defineComponent({
    name: "App",
  });
</script>
